import axios from 'axios';

const listAdditionalRecipients = ({ taxReturnId, companyId }) => {
  return axios.get(
    `/tax_returns/${taxReturnId}/tax_return_additional_recipients`,
    {
      params: {
        company_id: companyId,
      },
    },
  );
};

const addAdditionalRecipient = ({ taxReturnId, companyId, userId }) => {
  return axios.post(
    `/tax_returns/${taxReturnId}/tax_return_additional_recipients`,
    {
      company_id: companyId,
      user_id: userId,
    },
  );
};

const removeAdditionalRecipient = ({ id, taxReturnId, companyId }) => {
  return axios.delete(
    `/tax_returns/${taxReturnId}/tax_return_additional_recipients/${id}`,
    {
      data: {
        company_id: companyId,
      },
    },
  );
};

export default {
  listAdditionalRecipients,
  addAdditionalRecipient,
  removeAdditionalRecipient,
};
